var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorEnterFilled = function SvgDoorEnterFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2H5C2.243 2 0 4.243 0 7v10c0 2.757 2.243 5 5 5h4zM4 6h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2m1 10H4a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2m0-4H4a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2m19 5c0 2.757-2.243 5-5 5h-8V2h8c2.757 0 5 2.243 5 5zm-5.131-.293a.997.997 0 0 1-1.414 0l-2.583-2.583a3.003 3.003 0 0 1 0-4.243l2.583-2.583a.999.999 0 1 1 1.414 1.414l-2.583 2.583a1 1 0 0 0 0 1.415l2.583 2.583a1 1 0 0 1 0 1.414",
    clipRule: "evenodd"
  })));
};
export default SvgDoorEnterFilled;